document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('[data-toggle="collapse"]').forEach(function (toggler) {
		toggler.addEventListener('click', function () {
			const target = document.querySelector(toggler.dataset.target);
			if (!target || target.classList.contains('collapse-content--animating')) {
				return;
			}

			var isActive = target.classList.contains('collapse-content--active');

			if (isActive) {
				target.style.maxHeight = target.scrollHeight + 'px';
				target.classList.add('collapse-content--animating');
				target.classList.remove('collapse-content--active');
				toggler.classList.remove('collapse-toggler--active');

				setTimeout(function () {
					target.style.maxHeight = null;
				}, 0);
			} else {
				target.classList.add('collapse-content--animating');
				toggler.classList.add('collapse-toggler--active');
				target.style.maxHeight = target.scrollHeight + 'px';
			}

			setTimeout(function () {
				if (!isActive) {
					target.style.maxHeight = null;
					target.classList.add('collapse-content--active');
				}

				target.classList.remove('collapse-content--animating');
			}, 250);

		});
	});

	Fancybox.bind("[data-fancybox]", {
		l10n: Fancybox.l10n.cs,
	});
});